
<div class="footer" :class="{ active: isSidebarCollapsed }">
  <nav class="navbar navbar-default footer-navbar mb-0">
    <div class="container-fluid">
      <app-normal-button title="印刷" class="mr-2" :link="printableLink" target="_blank" />
      <app-normal-button title="コピー" class="mr-2" @click.native="copyToClipboard($event)" />
      <app-normal-squere-icon-button
        title="電子カルテへコピー済み"
        :checked="isCopied"
        @click.native="toggleIsCopied($event)"
      />
      <p v-if="customerDeleted" class="customer-deleted">※ 病院登録解除しているため送信できません</p>
      <app-primary-button
        :title="messageLinkTitle"
        :link="messageLink"
        :disabled="customerDeleted"
        class="ml-auto"
      />
    </div>
  </nav>

  <!-- eslint-disable-next-line vue/no-textarea-mustache -->
  <textarea id="clipboard">{{ clipboard }}</textarea>
</div>
